import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Morningstar Yacht · 200 m² Private Yacht in Vilamoura";
const DESC = "Meet Morningstar — a 200 m² private yacht based in Marina de Vilamoura. 18 guests, full sundeck, shaded lounge, bathroom, swim platform and a professional crew.";
const PATH = "/the-morningstar";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/the-morningstar")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "The Yacht · Vilamoura · Algarve",
        title: "Meet ",
        titleAccent: "Morningstar.",
        sub: "200 m² of teak deck, shaded lounge, bow sun pads, a marble bathroom and a swim platform — the largest private day-charter yacht in Marina de Vilamoura, for up to 18 guests.",
        ctaPrimary: "See specs",
        ctaSecondary: "Book a viewing",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "Morningstar yacht, Morningstar Vilamoura, Vilamoura yacht specs, private yacht 18 guests Vilamoura",
      altPath: { en: PATH, pt: "/pt/o-morningstar" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Morningstar Private Yacht",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "The Morningstar", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
